import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { LocalisableEntityData } from "./entity/localisable-entity.data";
/**
 *  Base model class that holds an EntityData. It holds the data that will be used as a parameter for the report and provides the method to generate a report.
 */
export class DataResourceModel {
    constructor(dataType) {
        this.dataType = dataType;
        /**
         * Define that the entity is read only
         */
        this._readonly = false;
        this._$readonlyChange = new BehaviorSubject(false);
        this.$readonlyChange = this._$readonlyChange.asObservable();
    }
    /**
     * Retrieves the name of the model
     * @returns {string}
     */
    getModelName() {
        return this.constructor.name;
    }
    /**
     * Retrieves the kebab case name of the model which is in a format that matches the naming convention of
     * the server side resource
     * @returns {string} Name of this model
     */
    getResourceName() {
        var s = this.getModelName();
        if (s.endsWith("Model")) {
            s = s.substr(0, s.length - "Model".length);
        }
        if (s.endsWith("Entity")) {
            s = s.substr(0, s.length - "Entity".length);
        }
        s = s.replace(/\.?([A-Z])/g, function (x, y) {
            return "-" + y.toLowerCase();
        }).replace(/^-/, "");
        console.log("returning " + s);
        return s;
    }
    get readonly() {
        return this._readonly;
    }
    set readonly(value) {
        this._readonly = value;
        this._$readonlyChange.next(value);
    }
    /**
     * Returns if the model is dealing with a localisable entity.
     * Checks if the type is an LocalisableEntityData to determine if the entity is localisable.
     * @returns {boolean}
     */
    isEntityLocalisable() {
        let entityObj = this.dataType;
        while (entityObj != null) {
            if (Object.getPrototypeOf(entityObj) === LocalisableEntityData) {
                return true;
            }
            entityObj = Object.getPrototypeOf(entityObj);
        }
        return false;
    }
    /**
     * Returns the version of the resource.
     * @returns {number}
     */
    getResourceVersion() {
        return 0;
    }
}
//# sourceMappingURL=data.resource.model.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fedelta-pos/data-client/resource/data.resource.model.js
// module id = 74
// module chunks = 1